import React from "react";

const HorseMoreInfo = ({ data }) => {
  const { title, details } = data;
  return (
    <div>
      <h2 className="font-display font-bold text-h2 text-green-800 mb-8">
        {title}
      </h2>
      <div className="flex flex-col gap-12">
        {details.map(({ title, description, icon }, index) => (
          <div className="border-solid border-0 border-b border-b-gray-400 last-of-type:border-b-0 pb-8">
            <div className="flex items-start gap-11 sm:gap-5">
              <h4 className="font-display text-h1 font-extrabold !text-yellow-400 leading-9 sm:text-h2">
                {index + 1}.
              </h4>
              <h3 className="font-display text-h3 font-extrabold text-gray-800">
                {title}
              </h3>
            </div>
            <div className="flex items-center mt-4 gap-14 pl-20 sm:pl-0 sm:gap-5">
              <p className="paragraph text-gray-600">{description}</p>
              <img src={icon?.src} className="w-9" />
            </div>
          </div>
        ))}
      </div>

      <div className="h-px w-full bg-gray-300 my-8" />
    </div>
  );
};

export default HorseMoreInfo;
